import { createElement as e, Component } from "react";
import {
  Form as BSForm,
  ButtonToolbar,
  Button,
  Alert,
  HelpBlock,
} from "react-bootstrap";
import { FieldGroup } from "sc/ui/components/FieldGroup";

const ERROR_ALERT_TYPE = "danger";
const SUCCESS_ALERT_TYPE = "success";

const compareFields = (f1, f2) => f1.position - f2.position;

export class Form extends Component {
  constructor(props) {
    super(props);
    // Compute initial step
    const initialState = {
      tosAccepted: false,
    };
    for (const key of Object.keys(props.fields)) {
      const field = props.fields[key];
      if (field.uiProps.type === "select") {
        const optionForInitialValue = field.uiProps.options.find(
          option => option.id === field.initialValue,
        );
        initialState[key] =
          optionForInitialValue === undefined ? "-1" : field.initialValue;
      } else {
        initialState[key] = field.initialValue;
      }
    }
    this.state = initialState;
    this.onChange = this.onChange.bind(this);
    this.validationState = this.validationState.bind(this);
    this.helpText = this.helpText.bind(this);
    this.hoverHelpText = this.hoverHelpText.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.props.clearUIError !== undefined && this.props.clearUIError();
  }

  onChange(fieldName) {
    return event => {
      const field = this.props.fields[fieldName];

      if (field.uiProps.type === "time") {
        this.setState({
          [fieldName]: `${event.format("HH:mm")}:00`,
        });
      } else if (field.uiProps.type === "timeZone") {
        this.setState({
          [fieldName]: event,
        });
      } else if (field.uiProps.type === "checkbox") {
        this.setState(state => ({
          [fieldName]: !state[fieldName],
        }));
      } else if (field.uiProps.type === "file" && event.target.files[0]) {
        const file = event.target.files[0];
        const value = event.target.value;
        const reader = new FileReader();
        reader.onloadend = () => {
          this.setState({
            file: reader.result,
          });
        };
        reader.readAsDataURL(file);
        this.setState({
          file: reader.result,
          fileObj: file,
          [fieldName]: value,
        });
      } else {
        this.setState({
          [fieldName]:
            field.onChange === undefined
              ? event.target.value
              : field.onChange(event.target.value),
        });
      }
      this.props.clearUIError();
    };
  }

  validationState(fieldName) {
    return (this.props.fields[fieldName].validationState = undefined);
  }

  helpText(fieldName) {
    return (this.props.fields[fieldName].help = undefined);
  }

  hoverHelpText(fieldName) {
    return this.props.fields[fieldName].hoverHelp === undefined
      ? undefined
      : this.props.fields[fieldName].hoverHelp(this.state[fieldName]);
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.clearUIError !== undefined && this.props.clearUIError();
    let trimmedState = {};
    for (const key of Object.keys(this.state)) {
      const value = this.state[key];
      if (key === "file") {
        trimmedState[key] = value;
      }
      if (key === "fileObj") {
        trimmedState[key] = value;
      } else {
        trimmedState[key] = typeof value === "string" ? value.trim() : value;
      }
    }
    const errorMessage = this.props.validation(trimmedState);
    if (errorMessage === undefined) {
      this.props.onSubmit(trimmedState);
    } else {
      this.props.onUIError(errorMessage);
    }
  }

  render() {
    return e(
      BSForm,
      this.props.formProps,
      Object.keys(this.props.fields)
        .sort(compareFields)
        .map(fieldName => {
          const { invisible, label, colsWidth, uiProps } = this.props.fields[
            fieldName
          ];
          return (
            invisible ||
            e(FieldGroup, {
              label,
              key: fieldName,
              id: fieldName,
              name: fieldName,
              onChange: this.onChange(fieldName),
              validationState: this.validationState(fieldName),
              value: this.state[fieldName],
              helpText: this.helpText(fieldName),
              hoverHelpText: this.hoverHelpText(fieldName),
              colsWidth,
              ...uiProps,
            })
          );
        }),
      e(
        "small",
        null,
        e(HelpBlock, this.props.helpProps),
        this.props.uiError &&
          e(
            Alert,
            {
              id: `error-box-${this.props.formProps.id}`,
              className: "error-box-marker",
              bsStyle: ERROR_ALERT_TYPE,
            },
            this.props.errorMessages[this.props.uiError] === undefined
              ? this.props.uiError
              : this.props.errorMessages[this.props.uiError],
          ),
        this.props.successMessage &&
          e(
            Alert,
            {
              id: `success-box-${this.props.formProps.id}`,
              bsStyle: SUCCESS_ALERT_TYPE,
            },
            this.props.successMessage,
          ),
      ),
      e(
        ButtonToolbar,
        null,
        this.props.submitButtonProps &&
          e(Button, {
            style: { float: "right" },
            id: `submit-${this.props.formProps.id}`,
            className: "submit-marker",
            type: "submit",
            bsStyle: "success",
            onClick: this.onSubmit,
            ...this.props.submitButtonProps,
          }),
      ),
    );
  }
}



// WEBPACK FOOTER //
// ./src/sc/ui/components/Form.js